import React, { memo, useState, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { ConditionalRendering } from '@common-components/conditional-rendering';
import NoEnrollmentMessage from './NoEnrollmentsMessage';
import EnrollmentContainer from './EnrollmentContainer';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { PLAN_TYPE } from '@modules/custom-grouping/modals/modalTypes';
import { LOGO_URLS } from '../hooks/useEnrollmentHistory';

const StyledPastEnrollmentDiv = styled.div`
    padding: 20px 0 10px 0;
    
    .tabs-container{
        border-bottom: 1px solid ${({ theme }) => theme.gray8};
    }
`;

const TAB_STATUS = {
    'ACTIVE': 'ACTIVE'
};

const PastEnrollmentContainer = (props: { inactiveHealthEnrollments: IEnrollmentDetails[], inactiveDentalEnrollments: IEnrollmentDetails[], coverageStartDateForDisenrollment: string, coverageYear: string }) => {

    const { inactiveHealthEnrollments, inactiveDentalEnrollments, coverageStartDateForDisenrollment, coverageYear } = { ...props };
    const [activeTab, setActiveTab] = useState('');
    const hasInActiveEnrollments = inactiveHealthEnrollments.length > 0 || inactiveDentalEnrollments.length > 0;

    useEffect(() => {
        if (inactiveHealthEnrollments.length > 0) {
            setActiveTab(PLAN_TYPE.HEALTH);
        } else if (inactiveDentalEnrollments.length > 0) {
            setActiveTab(PLAN_TYPE.DENTAL);
        }
    }, [inactiveHealthEnrollments, inactiveDentalEnrollments]);

    const handleTabClick = (e) => {
        e.preventDefault();
        if (e.target.className.toUpperCase() !== TAB_STATUS.ACTIVE) {
            setActiveTab((prevTab) =>
                prevTab === PLAN_TYPE.HEALTH ? PLAN_TYPE.DENTAL : PLAN_TYPE.HEALTH
            );
        }
    };

    return (
        <>
            <ConditionalRendering isTrue={hasInActiveEnrollments}>
                <StyledPastEnrollmentDiv id="pastEnrollmentTab">
                    <div className='float-none row margin-0 tabs-container'>
                        <ConditionalRendering isTrue={inactiveHealthEnrollments.length > 0}>
                            <div className="usa-nav__primary-item gi-main__nav__primary-item" data-testid="pastEnrollmentTabLink">
                                <div className="tab-link usa-nav__link gi-main__nav__primary-item__link" data-testid="health_tab" onClick={handleTabClick}>
                                    <div className={activeTab === PLAN_TYPE.HEALTH ? 'active' : ''}>
                                        <img src={LOGO_URLS.HEALTH} alt="Medical Plan Image" />
                                        &nbsp;<FormattedMessage id="indportal.enrollments.healthPlan" />
                                    </div>
                                </div>
                            </div>
                        </ConditionalRendering>
                        <ConditionalRendering isTrue={inactiveDentalEnrollments.length > 0}>
                            <div className="usa-nav__primary-item gi-main__nav__primary-item" data-testid="pastEnrollmentTabLink">
                                <div className="tab-link usa-nav__link gi-main__nav__primary-item__link" data-testid="dental_tab" onClick={handleTabClick}>
                                    <div className={activeTab === PLAN_TYPE.DENTAL ? 'active' : ''}>
                                        <img src={LOGO_URLS.DENTAL} alt="Dental Plan Image" />
                                        &nbsp;<FormattedMessage id="indportal.enrollments.dentalPlan" />
                                    </div>
                                </div>
                            </div>
                        </ConditionalRendering>
                    </div>
                    <ConditionalRendering isTrue={Boolean(activeTab)}>
                        <div data-testid={activeTab === PLAN_TYPE.HEALTH ? 'pastEnrollmentHealth' : 'pastEnrollmentDental'}>
                            <EnrollmentContainer enrollments={activeTab === PLAN_TYPE.HEALTH ? inactiveHealthEnrollments : inactiveDentalEnrollments} activeEnrollment='false' coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear} />
                        </div>
                    </ConditionalRendering>
                </StyledPastEnrollmentDiv>
            </ConditionalRendering>
            <ConditionalRendering isTrue={activeTab === ''}>
                <NoEnrollmentMessage />
            </ConditionalRendering>
        </>
    );
};

export default memo(PastEnrollmentContainer);